import { useEffect, useState } from "react";
import styles from "./DrawerIframe.module.scss";
import classNames from "classnames";
import { TTP_OFFFCOURSE_URL } from "../../../config";
import { encryptAES } from ".";
import { useSelector } from "react-redux";

const prepareWatchParams = (user, token, lng) => {
  const params = {};
  if (user && token) {
    params["auth"] = {
      id: user.id,
      token,
    };
  }
  if (lng) {
    params["preferences"] = { language: lng };
  }
  params["app"] = "WATCH";

  return encryptAES(JSON.stringify(params));
};

export default function WatchIframe({ lng }) {
  const [iframeSrc, setIframeSrc] = useState("");
  const [modalOpened, setModalOpened] = useState(false);

  const { token, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.event === "OPEN_MODAL") {
        setModalOpened(true);
      }
      if (event.data?.event === "CLOSE_MODAL") {
        setModalOpened(false);
      }
      if (event.data?.event === "OPEN_WEBINAR") {
        setIframeSrc(event.data.message);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (!token) {
      return;
    }

    const encryptedParams = prepareWatchParams(user, token, lng);
    const src =
      `${TTP_OFFFCOURSE_URL}/${lng}` +
      "?params=" +
      encodeURIComponent(encryptedParams);

    setIframeSrc(src);
  }, [lng, token]);

  return (
    <div className={classNames(styles.wrapper, modalOpened && styles.modalOpen)}>
      <iframe
        id="watch-iframe"
        src={iframeSrc}
        className={styles.iframe}
        allow="camera;microphone;autoplay;fullscreen"
      />
    </div>
  );
}
